import { apiRequest } from "../util/apiUtils";

export const scholarshipList = async (params) => {
  try {
    const res = await apiRequest("get", `scholarship/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const addEditScholarship = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `scholarship/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const scholarshipDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `scholarship/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const scholarshipApplicationList = async (params) => {
  try {
    const res = await apiRequest("get", `application/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const scholarshipApplicationDetails = async (params) => {
  try {
    const res = await apiRequest("get", `application/details`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const scholershipOrder = async (payload) => {
  try {
    const res = await apiRequest("patch", `scholarship/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const viewSubmittionDetails = async (params) => {
  try {
    const res = await apiRequest("get", `application-form/download-form?id=${params?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const scholarshipAppDelete = async (payload) => {
  try {
    const res = await apiRequest("post", `application-form/delete-submitted-form`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
